import { get, isNil, set } from 'lodash';
import { routeMap } from 'router';
import { injectParamsInRoute } from 'utils';

const MESSAGE_LINK_CODE = 11;
const CAMERAL_AUDIT_LINK_CODE = 12;

const linksById = {
  [MESSAGE_LINK_CODE]: {
    pathName: routeMap.messagesInfo,
    queryParamsMap: {
      cardId: 'cardId',
      notificationId: 'notificationId',
      eventType: 'eventTypeId',
    },
  },
  [CAMERAL_AUDIT_LINK_CODE]: {
    pathName: routeMap.cameralAudits,
    routeParamsMap: {
      id: 'notificationId',
    },
  },
};

export default function getLinkByCode(linkId, notificationData) {
  const linkOptions = {};
  const linkCodeMapping = linksById[linkId];

  if (!linkCodeMapping) {
    return null;
  }

  if (linkCodeMapping.queryParamsMap) {
    Object.keys(linkCodeMapping.queryParamsMap).forEach((key) => {
      if (!isNil(get(notificationData, linkCodeMapping.queryParamsMap[key]))) {
        set(
          linkOptions,
          `query.${key}`,
          get(notificationData, linkCodeMapping.queryParamsMap[key]),
        );
      }
    });
  }

  if (linkCodeMapping.routeParamsMap) {
    linkOptions.pathname = injectParamsInRoute(
      linkCodeMapping.pathName,
      Object.keys(linkCodeMapping.routeParamsMap).reduce(
        (acc, key) => ({
          ...acc,
          [key]: get(notificationData, linkCodeMapping.routeParamsMap[key]),
        }),
        {},
      ),
    );
  }

  return {
    pathname: linkCodeMapping.pathName,
    ...linkOptions,
  };
}
